import ConfigForm from './ConfigForm.jsx';

const SCHEMA = [
  { key: 'render_as', label: 'Render as', kind: 'text' },
];

export default function BooleanConfig({ field, onConfigChange }) {
  return <ConfigForm schema={SCHEMA} config={field.config} onConfigChange={onConfigChange} />;
}
